<template>
  <div class="news-school">
      <!-- <newsHeader :page="'优秀学校'"></newsHeader> -->
      <router-view></router-view>
      <scorllTop></scorllTop>
      <!-- <footer-view></footer-view> -->
  </div>
</template>

<script>
export default {
    
}
</script>

<style lang="less" scoped>
     @import "../less/news_common.less";
    .news-school {
        background-color: #fff;
        
        .left-section {
            width: 820px;
        }

        .school-list {
            padding: 20px 0 20px 20px;
        }
    }
</style>